import React from 'react'
import { Link } from 'react-router-dom'
import SectionTitle from '../SectionTitle'
import { useTranslation } from 'react-i18next'



const TeamSection = ({ teamsData, teamsError, teamsIsloading }) => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }
    const { t } = useTranslation();


    return (

        <section className="wpo-team-section section-padding">
            <div className="container">
                <SectionTitle
                    subTitle={t('aboutPage.team.subTitle')}
                    MainTitle={t('aboutPage.team.mainTitle')}
                />                <div className="wpo-team-wrap">
                    <div className="row">
                        {teamsIsloading ? <p>{t("loading")}...</p> : teamsError ? <p>{t("error")}</p> : teamsData?.map((team, aitem) => (
                            <div className="col-lg-3 col-md-4 col-sm-6 col-12" key={aitem}>
                                <div className="wpo-team-item">
                                    <div className="wpo-team-img">
                                        <img src={`${process.env.REACT_APP_API_URL}/api/images/${team?.data?.image}`} alt="" />
                                        <Link onClick={ClickHandler} to={`/team-single/${team.slug}`}><i className="ti-plus"></i></Link>
                                    </div>
                                    <div className="wpo-team-text">
                                        <h3><Link onClick={ClickHandler} to={`/team-single/${team.slug}`}>{team?.data?.name}</Link></h3>
                                        <span>{team?.data?.position}</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

            </div>
        </section>
    )
}

export default TeamSection;